if (!customElements.get('sp-customer-stories')) {
  customElements.define('sp-customer-stories', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      this.player = this.querySelector('[data-story-player]');
      this.error = this.querySelector('[data-story-error]');
      const gridStories = [...this.querySelectorAll('.sp-stories__grid .sp-story')];
      const emails = [...this.querySelectorAll('[data-email-after]')];
      const narrowGrid = window.matchMedia('(max-width:989px)');
      const initialStoryCount = 18;
      const emailPosition = (email) => {
        const after = Number(email.dataset.emailAfter);
        return narrowGrid.matches ? (after === 6 ? 6 : Math.ceil(after / 2) * 2 + 2) : after + 3;
      };
      const positionEmails = () => {
        emails.forEach((email) => {
          // Full-width emails must follow a complete two-column row.
          const position = emailPosition(email);
          const anchor = gridStories[Math.min(position, gridStories.length) - 1];
          if (anchor) anchor.after(email);
        });
      };
      positionEmails();
      narrowGrid.addEventListener('change', positionEmails, options);
      const extraStories = gridStories.slice(initialStoryCount);
      const more = this.querySelector('[data-story-more]');
      const extraEmails = emails.filter((email) => emailPosition(email) > initialStoryCount);
      extraEmails.forEach((email) => { email.hidden = true; });
      extraStories.forEach((story) => { story.hidden = true; });
      if (more) more.hidden = extraStories.length === 0;
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-story-more]')) {
          extraStories.forEach((story) => { story.hidden = false; }); extraEmails.forEach((email) => { email.hidden = false; });
          more.setAttribute('aria-expanded', 'true');
          extraStories[0]?.querySelector('[data-story-open]').focus();
          more.hidden = true;
        }
        if (event.target.closest('[data-story-next]')) {
          const stories = [...this.querySelectorAll('[data-story-open]')].filter((button) => !button.disabled);
          const next = stories[(stories.indexOf(this.trigger) + 1) % stories.length];
          if (next) {
            if (next.closest('.sp-story').hidden) { extraStories.forEach((story) => { story.hidden = false; }); extraEmails.forEach((email) => { email.hidden = false; }); if (more) { more.hidden = true; more.setAttribute('aria-expanded', 'true'); } }
            this.open(next);
          }
        }
        if (event.target.closest('[data-story-resume]')) {
          const video = this.player.querySelector('video');
          if (video) video.play().catch(() => {});
        }
        const trigger = event.target.closest('[data-story-open]');
        if (trigger && !trigger.disabled) this.open(trigger);
        if (event.target.closest('[data-story-close]')) this.dialog.close();
      }, options);
      this.dialog.addEventListener('click', (event) => {
        const bounds = this.dialog.getBoundingClientRect();
        if (event.target === this.dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => this.cleanup(), options);
    }
    open(trigger) {
      const template = trigger.closest('.sp-story').querySelector('[data-story-video]');
      if (!template) return;
      const switching = this.dialog.open;
      this.cleanup(!switching);
      this.trigger = trigger;
      if (!switching) this.dialog.showModal();
      const markup = template.content.querySelector('video');
      const video = document.createElement('video');
      video.controls = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.preload = 'auto';
      if (markup.getAttribute('poster')) video.poster = markup.getAttribute('poster');
      if (markup.getAttribute('aria-label')) video.setAttribute('aria-label', markup.getAttribute('aria-label'));
      const source = [...markup.querySelectorAll('source')].find((item) => item.type === 'video/mp4');
      const rawSource = source?.getAttribute('src') || markup.getAttribute('src');
      if (rawSource) {
        const url = new URL(rawSource, window.location.href);
        if (url.pathname.startsWith('/cdn/shop/videos/')) {
          url.hostname = 'cdn.shopify.com';
          url.pathname = url.pathname.replace('/cdn/shop/videos/', '/videos/');
          url.search = '';
        }
        video.src = url.href;
      }
      this.player.append(video);
      const status = document.createElement('p');
      status.className = 'sp-stories__loading';
      status.setAttribute('role', 'status');
      status.textContent = 'Loading video…';
      const resume = document.createElement('button');
      resume.type = 'button';
      resume.className = 'sp-stories__next';
      resume.dataset.storyResume = '';
      resume.textContent = 'Play video';
      resume.hidden = true;
      this.player.append(status, resume);
      video.addEventListener('playing', () => { status.hidden = true; resume.hidden = true; }, { signal: this.controller.signal });
      video.addEventListener('loadedmetadata', () => { video.style.aspectRatio = `${video.videoWidth} / ${video.videoHeight}`; }, { signal: this.controller.signal });
      video.addEventListener('stalled', () => { status.textContent = 'Video is buffering…'; resume.hidden = false; }, { signal: this.controller.signal });
      video.addEventListener('waiting', () => { status.hidden = false; }, { signal: this.controller.signal });
      video.addEventListener('error', () => { status.hidden = true; }, { signal: this.controller.signal });
      video.addEventListener('error', () => { this.error.hidden = false; }, { signal: this.controller.signal });
      this.querySelector('[data-story-next]').hidden = this.querySelectorAll('[data-story-open]:not(:disabled)').length < 2;
      this.previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      const playback = video.play();
      if (playback) playback.catch((error) => {
        if (!video.isConnected || error.name === 'AbortError') return;
        status.hidden = true;
        if (error.name === 'NotAllowedError') resume.hidden = false;
        else this.error.hidden = false;
      });
    }
    cleanup(restoreFocus = true) {
      const video = this.player?.querySelector('video');
      if (video) {
        video.pause();
        video.removeAttribute('src');
        video.querySelectorAll('source').forEach((source) => source.removeAttribute('src'));
        video.load();
      }
      this.player?.replaceChildren();
      if (this.error) this.error.hidden = true;
      if (this.previousOverflow !== undefined) {
        document.documentElement.style.overflow = this.previousOverflow;
        this.previousOverflow = undefined;
      }
      if (restoreFocus && this.trigger?.isConnected) this.trigger.focus();
      this.trigger = null;
    }
    disconnectedCallback() {
      this.dialog?.close();
      this.cleanup();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
